module.exports = __webpack_public_path__ + "static/media/Image_UC4_SSO_331_227@2X.d89709e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/usecases/Image_UC4_SSO_331_227@2X.png
// module id = 1275
// module chunks = 0